/**
 * Something on screen that must be asked before the visitor navigates away —
 * the shipment page while it holds unsaved edits. It is handed the navigation
 * and calls it once the visitor has chosen to save or discard; not calling it
 * keeps them where they are.
 */
export type LeaveGuard = (proceed: () => void) => void;

let current: LeaveGuard | null = null;

/** Set by the page that owns the edits, cleared again once it has none. */
export const setLeaveGuard = (guard: LeaveGuard | null): void => {
  current = guard;
};

export const hasLeaveGuard = (): boolean => current !== null;

/**
 * Every in-app way off a guarded page goes through here: the breadcrumb, the
 * round back button, the menu. Browser Back cannot be stopped this way — App
 * restores the URL first and then asks (see its popstate handler).
 */
export const leaveThrough = (proceed: () => void): void => {
  if (current === null) {
    proceed();
    return;
  }

  current(proceed);
};
